import { NonFunctionalPreviewField } from "./NonFunctionPreview";
import { disableReadOnlyFieldsSelector } from "../../store/selectors/clientSettings";
import { withDependentReferenceData } from "../../lib/customHooks/useReferenceData";
import { useSelector } from 'react-redux';
import { TextPreview } from "./TextPreview";
export const BarcodePreview = withDependentReferenceData(props => {
  const readOnlyFieldsDisabled = useSelector(disableReadOnlyFieldsSelector);
  return readOnlyFieldsDisabled ? <TextPreview {...props} /> : <NonFunctionalPreviewField {...props} />;
});